import {
  isBetaStage,
  isPersonalStack,
  isProdStage,
  isTestStage,
} from "../util/stageUtils";
import { getUser } from "../features/app/api";
import { MODULE_ID as AGENT_MODULE_ID } from "@amzn/loom-agent-assistance-widget-api";

export const WEBSITE_TITLE = "Devices ASIN Central";

// Devices ASIN Central Wiki link — shared by the footer and the
// App Shell Left Nav so both point at the same target.
export const WIKI_LINK_LABEL = "Devices ASIN Central Wiki";
export const WIKI_LINK_URL =
  "https://w.amazon.com/bin/view/PSLM/Working_with_us/ASIN_Central/";

export const RESULT_COLUMN_ID = "result";
export const PASS_EXCEPTION_REASON_COLUMN_ID = "passExceptionReason";

function getPersonalStackHost(): string {
  if (typeof window === "undefined") {
    return "unknown";
  }

  const hostName = window.location.hostname;
  const parts = hostName.split(".")[0]?.split("-");

  if (!parts || parts.length < 2) {
    return "unknown";
  }

  return parts[1];
}

export const Marketplaces: string[] = [
  "AE",
  "AU",
  "BE",
  "BR",
  "CA",
  "CN",
  "DE",
  "EG",
  "ES",
  "FR",
  "GB",
  "IN",
  "IE",
  "IT",
  "JP",
  "MX",
  "NL",
  "PL",
  "RU",
  "SA",
  "SE",
  "SG",
  "TR",
  "US",
];

export async function getBackendHost() {
  if (isProdStage()) {
    return "https://svc.asin-central.loom.devices.amazon.dev";
  }

  if (isBetaStage()) {
    return "https://svc.beta.asin-central.loom.devices.amazon.dev";
  }

  if (isPersonalStack()) {
    return `https://svc.test-${getPersonalStackHost()}.asin-central.loom.devices.amazon.dev`;
  }

  return "http://localhost:9000";
}

// Loom Agent Widget Package Configuration
const WIDGET_PACKAGE_MAPPING: { [key: string]: string } = {
  prod: `@amzn/${AGENT_MODULE_ID}-prod`,
  beta: `@amzn/${AGENT_MODULE_ID}-beta`,
  arimtz: `@amzn/${AGENT_MODULE_ID}-arimtz`,
  // Add your personal widget package
  // 'username': `@amzn/${AGENT_MODULE_ID}-username`,
};

export function getLoomAgentWidgetPackageName(): string {
  if (isProdStage()) {
    return WIDGET_PACKAGE_MAPPING["prod"];
  }

  if (isPersonalStack()) {
    const personalHost = getPersonalStackHost();
    return (
      WIDGET_PACKAGE_MAPPING[personalHost] || WIDGET_PACKAGE_MAPPING["beta"]
    );
  }

  // Default to beta
  return WIDGET_PACKAGE_MAPPING["beta"];
}
